// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamCard_container__EDd1C","avatar":"TeamCard_avatar__Hnqk3","info":"TeamCard_info__hHrn8","name":"TeamCard_name__Cm79E","role":"TeamCard_role__m7eCM"};